var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 318,
    height: 40,
    viewBox: "0 0 318 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.1793 1.58009C83.1793 1.57275 83.1862 1.56541 83.1862 1.55807C83.1862 1.03686 81.3372 0.611084 79.0622 0.611084C76.8283 0.611084 75.0138 1.02218 74.9451 1.5287L64.0165 22.6633C55.2012 42.7158 95.5788 44.6348 95.5788 27.0458L83.1793 1.58009Z",
    fill: "url(#paint0_linear_296_3547)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1543 16.1422H35.3812L45.8212 35.7666L56.3048 16.1422H60.488L48.1492 39.1057H43.4931L31.1543 16.1422Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.9708,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.521 26.1815C123.521 21.6195 120.502 19.3202 115.541 19.3202C110.15 19.3202 106.01 22.0589 105.923 27.1773V39.0325H102.125V16.069H105.923V20.5431C107.996 17.4164 111.706 15.7249 116.406 15.7249C123.049 15.7249 127.319 19.4154 127.319 25.581V39.0399H123.521V26.1815Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.9708,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M141.041 16.501H146.992V19.8474H141.041V30.6995C141.041 34.434 141.776 35.7813 144.621 35.7813C145.566 35.7813 146.476 35.6495 147.341 35.4738L146.738 38.9886C146.003 39.1643 144.882 39.2961 143.849 39.2961C138.844 39.2961 137.251 36.7772 137.251 31.0876V19.8401H132.289V16.4937H137.251V11.5437L141.048 8.72449V16.501H141.041Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.9708,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M172.571 25.7494C172.571 21.7952 170.33 19.3202 165.841 19.3202C161.185 19.3202 157.598 22.0955 157.518 26.6574V39.0325H153.721V16.069H157.518V20.1477C159.417 17.3285 162.655 15.7175 166.707 15.7175C171.239 15.7175 174.346 17.8484 175.597 21.2314C177.409 17.7605 181.032 15.7175 185.564 15.7175C191.646 15.7175 195.226 19.5838 195.226 24.9659V39.0325H191.428V25.7494C191.428 21.7952 189.187 19.3202 184.699 19.3202C180.21 19.3202 176.456 22.1394 176.376 26.6574V39.0325H172.578V25.7494H172.571Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.9708,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M223.257 33.8262C220.929 37.4289 216.44 39.384 211.311 39.384C205.833 39.384 202.428 36.3452 202.428 32.5228C202.428 25.4419 212.264 24.4021 221.54 24.4021C221.925 24.4021 222.362 24.4021 222.791 24.4021C222.187 20.4918 218.782 19.3202 214.468 19.3202C210.889 19.3202 207.397 20.6676 205.498 22.7472L203.126 19.7962C205.803 17.3212 210.678 15.7175 214.905 15.7175C222.195 15.7175 226.771 18.9761 226.771 26.3572V31.8711C226.771 34.8221 227.593 35.7374 229.317 35.7374C230.008 35.7374 231.216 35.6056 231.82 35.3932L231.172 38.952C230.656 39.1277 229.317 39.2961 228.495 39.2961C225.607 39.2961 223.751 37.9927 223.359 34.4779C223.3 34.2582 223.257 34.0386 223.257 33.8262ZM222.951 27.3531C215.232 27.3531 206.473 27.6972 206.473 32.1713C206.473 34.6903 208.932 35.9058 211.82 35.9058C217.429 35.9058 222.689 33.0866 222.951 28.1366V27.3531Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.9708,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M236.586 6.46912H240.384V26.5695C245.6 23.0986 250.736 19.5765 255.96 16.0617H261.482L249.056 24.4826L262.777 39.0252H257.859L246.036 26.5183L240.384 30.2967V39.0252H236.586V6.46912Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.9708,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M303.751 39.0325H299.953V16.069H303.751V20.5431C305.737 17.4603 309.229 15.7249 313.5 15.7249C314.191 15.7249 315.267 15.7688 315.915 15.8127L316.606 20.1111C315.915 19.8474 314.365 19.6351 313.238 19.6351C307.759 19.6351 303.744 22.198 303.744 27.624V39.0325H303.751Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.9708,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1366 27.602C28.1366 20.0891 22.6583 15.7908 14.5465 15.7908C6.47825 15.7908 1 20.133 1 27.646C1 35.115 6.5219 39.4573 15.1067 39.4573C20.5849 39.4573 25.2047 37.5021 27.4891 33.9873L23.6987 33.1672C21.0578 35.6202 17.1728 35.8912 15.1139 35.8912C9.41744 35.8912 5.23418 33.3283 4.89224 28.3782C4.81222 27.2432 4.87042 26.1815 5.15415 25.2515C6.14358 21.3413 9.68662 19.3495 14.561 19.3495C19.3918 19.3495 22.9712 21.3925 23.9242 25.2515H8.31888L9.0755 28.3782H28.1366V27.602Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.9708,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M292.926 27.5288C292.926 20.0159 287.447 15.7175 279.336 15.7175C271.267 15.7175 265.789 20.0598 265.789 27.5727C265.789 35.0417 271.311 39.384 279.896 39.384C285.374 39.384 289.994 37.4289 292.278 33.9141L288.488 33.0939C285.847 35.547 281.962 35.8179 279.903 35.8179C274.207 35.8179 270.023 33.255 269.681 28.305C269.601 27.17 269.659 26.1082 269.943 25.1783C270.933 21.268 274.476 19.2763 279.35 19.2763C284.181 19.2763 287.76 21.3193 288.713 25.1783H273.123L273.879 28.305H292.94V27.5288H292.926Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.9708,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0622 26.6061L92.4014 27.8154C92.2199 28.6642 91.8974 29.513 91.4136 30.3768C91.3464 30.4745 91.2994 30.5796 91.2255 30.6848C89.8951 32.5401 88.0003 33.9974 85.5545 34.9363C84.2845 35.3795 82.8399 35.7025 81.2407 35.9353C80.9652 35.9654 80.6965 36.0104 80.421 36.0255H79.1376H77.8542C77.572 36.0104 77.3032 35.9654 77.0345 35.9353C75.4353 35.71 73.9839 35.3795 72.7207 34.9363C70.2749 33.9974 68.3734 32.5401 67.0497 30.6848C66.9758 30.5871 66.9288 30.482 66.8616 30.3768C65.894 28.6567 65.558 26.9591 65.7731 25.2991C66.0015 23.5489 66.707 21.979 67.809 20.5668L67.7821 20.5819C68.8101 19.3199 70.1271 18.3284 71.7397 17.5698C73.8496 16.5707 76.0871 16.0675 78.5799 15.9773H79.9842L82.1008 16.2102C83.6462 16.4581 85.1177 16.9012 86.5422 17.5698C88.1548 18.3284 89.4718 19.3199 90.4998 20.5819L90.4729 20.5668C90.6476 20.7922 90.8156 21.025 90.9702 21.2579L71.9077 29.9111L71.9144 29.9412C72.5124 30.5045 73.2784 30.9477 74.2527 31.2482L93.5974 22.4973C93.5705 22.4597 93.5436 22.4222 93.5235 22.3771C93.4428 22.2344 93.3756 22.0992 93.2883 21.964L93.248 21.9414C91.7832 19.7331 89.6666 18.0956 86.9386 16.8637C85.3327 16.1426 83.6932 15.6844 81.9731 15.444L79.9506 15.2562L78.5933 15.2637C75.9728 15.3389 73.6009 15.8421 71.3231 16.8712C68.5951 18.1031 66.4786 19.7406 65.0138 21.9489L64.9735 21.9715C64.8861 22.1142 64.8189 22.2494 64.7383 22.3846C64.6845 22.4672 64.6241 22.5574 64.5703 22.64C64.5098 22.7452 64.4695 22.8428 64.4158 22.948C64.3754 23.0231 64.3351 23.1057 64.2948 23.1808C62.736 26.2305 62.6352 29.4454 64.5837 32.6453C66.8683 36.4085 71.088 38.8197 76.9337 39.3155C76.9942 39.323 77.0546 39.323 77.1151 39.323C77.6728 39.3681 78.2305 39.4131 78.8084 39.4206C78.9159 39.4206 79.0167 39.4056 79.1309 39.4056C79.2384 39.4056 79.3392 39.4206 79.4534 39.4206C80.0313 39.4131 80.589 39.3681 81.1467 39.323C81.2071 39.3155 81.2676 39.3155 81.3281 39.3155C87.1738 38.8272 91.3935 36.4085 93.678 32.6453C94.9009 30.6172 95.3175 28.5891 95.0622 26.6061Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.9708,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_296_3547",
    x1: 80.2085,
    y1: -10.1695,
    x2: 79.0965,
    y2: 26.2701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2259,
    stopColor: "white",
    stopOpacity: 0.7741
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4744,
    stopColor: "white",
    stopOpacity: 0.5256
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6954,
    stopColor: "white",
    stopOpacity: 0.3046
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8782,
    stopColor: "white",
    stopOpacity: 0.1218
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cf5a3bbaba5be5a255241ce5901a4ec4.svg";
export { ForwardRef as ReactComponent };